import { Box, Button } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

interface Props {
  setReload: (arg0: boolean) => void
  reload: boolean
}

const EmployeeCodeNotSynced = ({ setReload, reload }: Props) => {
  // TODO: make it generic for other integrations
  const a3InnuvaUrl = 'https://a3innuva.wolterskluwer.es/'

  return (
    <Box
      background="white"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{
        all: 'abs008',
      }}
      gap="s16"
    >
      <Callout
        type="critical"
        title={i18n.t(
          'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.missing_employee_code_title'
        )}
        description={i18n.t(
          'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.missing_employee_code_message'
        )}
        link={
          <a rel="nofollow noopener noreferrer" target="_blank" href={a3InnuvaUrl}>
            a3Innuva web
          </a>
        }
      />
      <Button
        onClick={() => {
          setReload(!reload)
        }}
      >
        {i18n.t('payroll_integrations.incidences.a3innuva.employee_code_not_synced.try_again')}
      </Button>
    </Box>
  )
}

export default EmployeeCodeNotSynced
